export default __webpack_public_path__ + "static/media/cup_&_cone.4f5ced75.png";